module.exports = __webpack_public_path__ + "static/media/loading2.b1e70028.png";